import {
  Button,
  createStyles,
  Dialog,
  Theme,
  WithStyles,
  withStyles,
  Drawer,
  Divider,
  AppBar,
  CssBaseline,
  Toolbar,
  Typography,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Grid,
  ButtonBase,
  List,
  IconButton,
  ThemeProvider,
  ListItemSecondaryAction,
} from "@material-ui/core";
import deepOrange from "@material-ui/core/colors/deepOrange";
import * as React from "react";
import EyeViewIcon from "@material-ui/icons/Visibility";
import ImageIcon from "@material-ui/icons/Image";
import DialpadIcon from "@material-ui/icons/Dialpad";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import CalendarIcon from "@material-ui/icons/CalendarToday";
import ViewSignatureDialog from "./ViewSignatureDialog";
import {
  getInspectionLabel,
  getMomentDate,
  getMomentDateTime,
  convertTextToTitleCase,
} from "../constants/constants";
import { AssetsService } from "../services/AssetsService";
import LoadingComponents from "../components/LoadingComponents";
import { PhotoService } from "../services/PhotoService";
import imagePlacholder from "../assets/images/image-placeholder.png";
import { defaultTheme } from "../utils/theme";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import ViewInspectionDialog from "./ViewInspectionDialog";
const drawerWidth = "30%";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    tabRoot: {
      flexGrow: 1,
    },
    focusVisible: {},
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    img: {
      margin: "auto",
      display: "block",
      maxWidth: "80%",
      maxHeight: "80%",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    drawerPaper: {
      marginTop: 64,
      width: drawerWidth,
    },
    image: {
      width: 128,
      height: 128,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: 5,
    },
    media: {
      height: 200,
      width: 300,
      padding: 10,
      alignSelf: "center",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    fab: {
      position: "fixed",
      zIndex: 100,
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    section3: {
      margin: theme.spacing(3, 3, 3),
    },
    chip: {
      margin: theme.spacing(0.5),
      color: theme.palette.getContrastText(deepOrange[500]),
    },
    imageTitle: {
      position: "relative",
      padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${
        theme.spacing(1) + 6
      }px`,
    },
    imageMarked: {
      height: 3,
      width: 18,
      backgroundColor: theme.palette.common.white,
      position: "absolute",
      bottom: -2,
      left: "calc(50% - 9px)",
      transition: theme.transitions.create("opacity"),
    },
    signChip: {
      padding: 5,
      margin: 5,
      width: 120,
      height: 44,
    },
    imageButton: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.common.white,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      marginLeft: "30%",
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  inspectionData: any;
  handleClose: any;
  company: any;
}
class ViewWorkFlowInspectionDialog extends React.Component<Props> {
  state = {
    signatures: Array<any>(),
    openSignatureDialog: false,
    openEditDialog: false,
    editQuestionItem: { question: "", _id: "" },
    selectedSignature: {},
    selectedTab: 0,
    isLoading: false,
    openViewImage: false,
    selectImageToView: {},
    openViewInspectionDialog: true,
    completedRowSelected: {},
  };

  componentDidMount = async () => {
    const { inspectionData } = this.props;
    if (inspectionData.inspection) {
      let signitories = inspectionData.inspection.signotoriesItems;
      let inspectionsItems = inspectionData.inspection.inspectionsItems;
      let breakdowns = inspectionData.inspection.breakdowns;
      if (signitories) {
        // for (var i = 0; i < signitories.length; i++) {
        //   let signatureItem = signitories[i];
        //   if (signatureItem.value && signatureItem.value.signatureValue) {
        // signatureItem = await this.downloadSignatoriesItemsImages(
        //   signatureItem
        // );
        //   }
        // }
      }
      if (inspectionsItems) {
        this.downloadInspectionItemsAssets(inspectionsItems);
      }
      this.downloadBreakdownAssets(breakdowns);
    }
  };

  componentDidUpdate = async (prevProps: any, prevState: any) => {
    if (prevProps.inspectionData !== this.props.inspectionData) {
      const { inspectionData } = this.props;
      let signitories = inspectionData.inspection.signotoriesItems;
      let inspectionsItems = inspectionData.inspection.inspectionsItems;
      let breakdowns = inspectionData.inspection.breakdowns;
      let standings = inspectionData.inspection.standings;
      if (signitories) {
        let photoService: PhotoService = new PhotoService();
        for (var i = 0; i < signitories.length; i++) {
          let signatureItem = signitories[i];
          if (signatureItem.value && signatureItem.value.signatureValue) {
            let signatureValue = signatureItem.value.signatureValue;
            photoService
              .downloadQuestionPhoto(signatureValue._id)
              .then((resp: any) => {
                if (resp && resp.data) {
                  let mData = resp.data;
                  signatureItem.value.signatureValue = mData;
                }
              });
          }
        }
      }
      if (inspectionData.inspection && inspectionData.inspection.imageItem) {
        this.downloadQuestionAsset(inspectionData.inspection.imageItem);
      }
      if (inspectionsItems) {
        this.downloadInspectionItemsAssets(inspectionsItems);
      }
      this.downloadBreakdownAssets(breakdowns);
      this.downloadStandingAssets(standings);
    }
  };

  downloadInspectionItemsAssets = (inspectionsItems: any) => {
    if (!inspectionsItems) {
      return;
    }
    inspectionsItems.map((inspectionItem: any) => {
      if (inspectionItem.questions) {
        inspectionItem.questions.map((questionItem: any) => {
          if (questionItem.value && questionItem.value.images) {
            let images = Array<any>();
            questionItem.value.images.map(
              async (imageItem: any, index: any) => {
                let resp = await this.downloadQuestionPhoto(imageItem._id);
                if (resp && resp.data) {
                  let objImages = { imageId: imageItem._id, base64: resp.data };
                  images.push(objImages);
                }
                return null;
              }
            );
            questionItem.value.images = images;
          }
          return null;
        });
      }
      this.downloadQuestionAsset(inspectionItem.imageItem);
      return null;
    });
  };

  downloadBreakdownAssets = (breakdowns: any) => {
    if (!breakdowns) {
      return;
    }
    breakdowns.map((breakdownItem: any) => {
      this.downloadBreakdownImages(breakdownItem);
      return null;
    });
  };
  downloadStandingAssets = (standings: any) => {
    if (!standings) {
      return;
    }
    standings.map((standingItem: any) => {
      this.downloadStandingImages(standingItem);
      return null;
    });
  };
  downloadSignatoriesItemsImages = async (signatureItem: any) => {
    let photoService: PhotoService = new PhotoService();
    let signatureValue = signatureItem.value.signatureValue;
    let resp = await photoService.downloadQuestionPhoto(signatureValue._id);
    if (resp && resp.data) {
      let mData = resp.data;
      signatureItem.value.signatureValue = mData;
    }
    return signatureItem;
  };
  downloadBreakdownImages = (breakDownItem: any) => {
    if (!breakDownItem) {
      return null;
    }
    if (breakDownItem.images && breakDownItem.images.length > 0) {
      let images: any = new Array<any>();
      breakDownItem.images.map(async (imageItem: any, index: any) => {
        let resp = await this.downloadQuestionPhoto(imageItem._id);
        if (resp && resp.data) {
          let objImages = { imageId: imageItem._id, base64: resp.data };
          images.push(objImages);
        }
        return null;
      });
      breakDownItem.images = images;
    }
    if (
      breakDownItem.artisanPersons &&
      breakDownItem.artisanPersons.length > 0
    ) {
      let artisanPersons = breakDownItem.artisanPersons;
      for (var h = 0; h < artisanPersons.length; h++) {
        let artisanPerson = artisanPersons[h];
        if (
          artisanPerson &&
          artisanPerson.images &&
          artisanPerson.images.length > 0
        ) {
          let artisanPersonImages: any = new Array<any>();
          artisanPerson.images.map(async (imageItem: any, index: any) => {
            let resp = await this.downloadQuestionPhoto(imageItem._id);
            if (resp && resp.data) {
              let objImages = { imageId: imageItem._id, base64: resp.data };
              artisanPersonImages.push(objImages);
            }
            return null;
          });
          artisanPerson.images = artisanPersonImages;
        }
      }
    }
  };

  downloadStandingImages = (standingItem: any) => {
    if (!standingItem) {
      return null;
    }
    if (standingItem.images && standingItem.images.length > 0) {
      let images: any = new Array<any>();
      standingItem.images.map(async (imageItem: any, index: any) => {
        let resp = await this.downloadQuestionPhoto(imageItem._id);
        if (resp && resp.data) {
          let objImages = { imageId: imageItem._id, base64: resp.data };
          images.push(objImages);
        }
        return null;
      });
      standingItem.images = images;
    }
  };

  downloadQuestionPhoto = async (imageId: any) => {
    let photoService: PhotoService = new PhotoService();
    this.setState({
      isLoading: false,
    });
    return photoService.downloadQuestionPhoto(imageId);
  };
  downloadQuestionAsset = (imageItem: any) => {
    let assetsService: AssetsService = new AssetsService();
    this.setState({
      isLoading: true,
    });
    assetsService.getAsset(imageItem.filename).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.data) {
        imageItem.base64 = resp.data;
      }
    });
  };

  getEquipmentName = () => {
    const { inspectionData } = this.props;
    let equipmentValue = inspectionData.inspection.equipment;
    if (!equipmentValue) {
      var nameArr = inspectionData.inspection.name.split(" ");
      if (nameArr.length > 0) {
        equipmentValue = nameArr[0];
      } else {
        inspectionData.inspection.headerItems.map((headerItem: any) => {
          if (headerItem.title === "Equipment Name") {
            equipmentValue = headerItem.value;
          }
          return null;
        });
      }
    }
    return equipmentValue;
  };

  getLicenseDetailsItem = (licenseDetails: any, headerItem: any) => {
    let equipmentValue = this.getEquipmentName();
    let value = null;
    licenseDetails.map((licenseItem: any) => {
      let name = equipmentValue.replace("-", " ");
      if (licenseItem.authorizedEquipment.label === equipmentValue) {
        value = new Date(licenseItem[headerItem.licenseDetail]);
      } else if (licenseItem.authorizedEquipment.label.includes(name)) {
        value = new Date(licenseItem[headerItem.licenseDetail]);
      } else {
        return null;
      }
      return null;
    });
    return value;
  };

  getValueByType = (type: string, value: any, thr?: any) => {
    switch (type.toUpperCase()) {
      case "DATE":
        if (
          (value instanceof Object && thr.title.includes("Licence")) ||
          thr.title.includes("License")
        ) {
          let mDate = this.getLicenseDetailsItem(value, thr);
          let mDateValue = mDate ? mDate : "";
          return getMomentDate(mDateValue);
        } else {
          return getMomentDate(value);
        }
      case "TEXT":
        return value;
      case "NUMBER":
        return value;
      default: {
        return value;
      }
    }
  };
  getIcon = (type: string) => {
    switch (type) {
      case "Date":
        return <CalendarIcon />;
      case "Text":
        return <TextFieldsIcon />;
      case "Number":
        return <DialpadIcon />;
      default: {
      }
    }
  };
  getBase64 = (signatureItemArg: any) => {
    if (!signatureItemArg) {
      return "";
    }
    let base64 = "";
    this.state.signatures.map((signatureItem: any) => {
      if (signatureItemArg._id === signatureItem.signatureId) {
        base64 = signatureItem.base64;
      }
      return null;
    });
    return base64;
  };
  handleClose = () => {
    this.setState({
      openSignatureDialog: false,
      openEditDialog: false,
      openViewImage: false,
      openViewInspectionDialog: false,
      selectImageToView: {},
    });
  };
  handleViewSignature = (base64: any, signatureItem: any) => {
    this.setState({
      selectedSignature: { base64: base64, signatureItem: signatureItem },
      openSignatureDialog: true,
    });
  };

  renderSignatureDialog = () => {
    return (
      <ViewSignatureDialog
        dialogTitle={"Signature"}
        onClose={this.handleClose}
        open={this.state.openSignatureDialog}
        signature={this.state.selectedSignature}
      />
    );
  };
  renderFormsItems = (formsItem: any) => {
    return (
      <div style={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item>
                {formsItem.map((mItem: any, index: any) => {
                  let signatureItem =
                    mItem.responseType === "SIGNATURE"
                      ? mItem.signatureItem
                      : null;
                  return (
                    <div key={index.toString()}>
                      <div>
                        <ListItem>
                          <ListItemText
                            primary={mItem.formsInput}
                            secondary={
                              mItem.value
                                ? mItem.value
                                : signatureItem.who
                                ? signatureItem.who
                                : ""
                            }
                          />
                        </ListItem>
                        {signatureItem && (
                          <Paper>
                            <ListItem
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <ListItemText
                                primary={
                                  signatureItem.value &&
                                  signatureItem.value.fullName
                                    ? signatureItem.value.fullName
                                    : ""
                                }
                                secondary={`Signed On:${getMomentDateTime(
                                  signatureItem.value &&
                                    signatureItem.value.signedOn
                                    ? signatureItem.value.signedOn
                                    : ""
                                )}`}
                              />
                              {signatureItem.value &&
                                signatureItem.value.signatureValue && (
                                  <div>
                                    <IconButton
                                      style={{
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      onClick={() =>
                                        this.handleViewSignature(
                                          signatureItem.value.signatureValue,
                                          signatureItem.value
                                        )
                                      }
                                    >
                                      <EyeViewIcon />
                                    </IconButton>
                                    Open Signature
                                  </div>
                                )}
                            </ListItem>
                          </Paper>
                        )}
                      </div>
                    </div>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };
  renderViewInspectionDialog = () => {
    return (
      <ViewInspectionDialog
        open={this.state.openViewInspectionDialog}
        handleClose={this.handleClose}
        inspectionData={this.state.completedRowSelected}
        company={this.props.company}
      />
    );
  };
  render() {
    const { open, handleClose, inspectionData, classes, company } = this.props;
    return (
      <React.Fragment>
        {this.renderSignatureDialog()}
        {this.renderViewInspectionDialog()}
        {inspectionData && inspectionData.inspection && (
          <Dialog
            open={open}
            keepMounted={true}
            onClose={() => handleClose()}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullScreen={true}
            maxWidth={"md"}
          >
            <CssBaseline />
            <ThemeProvider theme={defaultTheme}>
              <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                  <Typography variant="h6" className={classes.title}>
                    Viewing Workflow Inspection
                  </Typography>
                  <Button
                    type="submit"
                    onClick={() => handleClose()}
                    color="inherit"
                  >
                    Close
                  </Button>
                </Toolbar>
              </AppBar>
            </ThemeProvider>
            <Drawer
              className={classes.drawer}
              variant="permanent"
              classes={{
                paper: classes.drawerPaper,
              }}
              anchor="left"
            >
              <Divider />
              <div style={{ paddingRight: 20 }}>
                <div
                  style={{
                    padding: 10,
                    flexDirection: "column",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <ListItemText
                    primary={`${inspectionData.inspection.name} - ${inspectionData.inspection.inspectionType}`}
                    secondary={
                      getInspectionLabel(
                        inspectionData.inspection.category,
                        company.inspectionCategories
                      ).label
                    }
                  />
                  {inspectionData.inspection &&
                  inspectionData.inspection.imageItem &&
                  inspectionData.inspection.imageItem.base64 ? (
                    <ButtonBase
                      focusRipple
                      className={classes.media}
                      onClick={() => {
                        this.setState({
                          selectImageToView:
                            inspectionData.inspection.imageItem,
                          openViewImage: true,
                        });
                      }}
                    >
                      <img
                        className={classes.media}
                        src={`data:image/jpeg;base64,${inspectionData.inspection.imageItem.base64}`}
                        alt={"inspections card"}
                      />
                    </ButtonBase>
                  ) : (
                    <img
                      className={classes.media}
                      src={imagePlacholder}
                      alt={"inspections card2"}
                    />
                  )}
                  <Paper
                    elevation={3}
                    style={{
                      width: "80%",
                      height: 50,
                      margin: 10,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant={"h2"}
                      style={{ fontSize: 18, color: "black" }}
                    >
                      INSPECTOR
                    </Typography>
                  </Paper>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <ImageIcon />
                      </Avatar>
                    </ListItemAvatar>
                    {inspectionData.assign &&
                      inspectionData.assign.assignedTo && (
                        <ListItemText
                          primary={"Assigned to:"}
                          secondary={inspectionData.assign.assignedTo.fullName}
                        />
                      )}
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <CalendarIcon />
                      </Avatar>
                    </ListItemAvatar>
                    {inspectionData.assign && inspectionData.assign.assignedTo && (
                      <Grid
                        container
                        direction="row"
                        justify="space-evenly"
                        alignItems="center"
                      >
                        <ListItemText
                          primary={"Received on:"}
                          secondary={getMomentDate(
                            inspectionData.assign.receivedOn
                          )}
                        />
                        <ListItemText
                          primary={"Completed on:"}
                          secondary={getMomentDate(
                            inspectionData.assign.completionDate
                          )}
                        />
                      </Grid>
                    )}
                  </ListItem>
                  {inspectionData.inspection &&
                    inspectionData.inspection.signotoriesItems &&
                    inspectionData.inspection.signotoriesItems.length > 0 && (
                      <Paper
                        elevation={3}
                        style={{
                          width: "80%",
                          height: 50,
                          margin: 10,
                          alignSelf: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant={"h2"}
                          style={{ fontSize: 18, color: "black" }}
                        >
                          SiGNATORIES
                        </Typography>
                      </Paper>
                    )}
                  {inspectionData.inspection &&
                    inspectionData.inspection.signotoriesItems &&
                    inspectionData.inspection.signotoriesItems.length > 0 && (
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar>
                            <ImageIcon />
                          </Avatar>
                        </ListItemAvatar>
                        {inspectionData.assign &&
                          inspectionData.assign.assignedTo && (
                            <Grid container direction="column">
                              {inspectionData.inspection.signotoriesItems.map(
                                (signatureItem: any, index: any) => {
                                  let objBase64 =
                                    signatureItem.value &&
                                    signatureItem.value.signatureValue
                                      ? signatureItem.value.signatureValue
                                      : "";
                                  if (signatureItem.value) {
                                    return signatureItem.value ===
                                      "NOT_SIGNED" ? (
                                      <div>
                                        <Typography>
                                          {convertTextToTitleCase(
                                            signatureItem.who
                                          )}
                                        </Typography>
                                        <Typography
                                          style={{ color: "red" }}
                                          variant={"caption"}
                                        >
                                          No Signature
                                        </Typography>
                                      </div>
                                    ) : (
                                      <div
                                        key={index.toString()}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <ListItemText
                                          primary={signatureItem.value.fullName}
                                          secondary={`Signed On:${getMomentDateTime(
                                            signatureItem.value.signedOn
                                          )}`}
                                        />
                                        {objBase64 && (
                                          <div>
                                            <IconButton
                                              style={{
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                              onClick={() =>
                                                this.handleViewSignature(
                                                  objBase64,
                                                  signatureItem.value
                                                )
                                              }
                                            >
                                              <EyeViewIcon />
                                            </IconButton>
                                            Open Signature
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                  return null;
                                }
                              )}
                            </Grid>
                          )}
                      </ListItem>
                    )}
                </div>
              </div>
            </Drawer>
            <main className={classes.content}>
              <div className={classes.toolbar} />
              <Typography variant={"h5"} style={{ padding: 5 }}>
                Workflow Inspection steps
              </Typography>
              <Paper>
                <List>
                  {inspectionData.inspection.workflows.map(
                    (obj: any, index: any) => {
                      let inspectionType = getInspectionLabel(
                        obj.workflow.inspection.inspectionType,
                        this.props.company.inspectionTypes
                      );
                      return (
                        <div
                          key={`${index.toString()}-workflow-item`}
                          style={{ width: "100%" }}
                        >
                          <ListItem>
                            <ListItemText
                              primary={`Step name: ${
                                obj.stepName ? obj.stepName : ""
                              }`}
                              secondary={`Step description: ${
                                obj.stepDescription ? obj.stepDescription : ""
                              }`}
                            />
                            <ListItemText
                              style={{ marginRight: 20 }}
                              primaryTypographyProps={{ align: "right" }}
                              secondaryTypographyProps={{
                                align: "right",
                              }}
                              primary={
                                obj.workflow && obj.workflow.inspection.name
                                  ? obj.workflow.inspection.name
                                  : ""
                              }
                              secondary={`${
                                obj.workflow &&
                                obj.workflow.inspection.inspectionType
                                  ? inspectionType && inspectionType.label
                                    ? inspectionType.label
                                    : ""
                                  : ""
                              } ${
                                obj.workflow && obj.workflow.category
                                  ? obj.workflow.category
                                  : ""
                              }`}
                            />
                            <ListItemSecondaryAction
                              style={{
                                marginLeft: 10,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <IconButton
                                style={{
                                  width: 30,
                                  height: 30,
                                  marginLeft: 5,
                                  marginRight: 2,
                                }}
                                edge="end"
                                aria-label="delete"
                                onClick={() => {
                                  this.setState({
                                    openViewInspectionDialog: true,
                                    completedRowSelected: obj.workflow,
                                  });
                                }}
                              >
                                <ViewCompactIcon fontSize={"small"} />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <Divider />
                        </div>
                      );
                    }
                  )}
                </List>
              </Paper>
            </main>
          </Dialog>
        )}
        <LoadingComponents isLoading={this.state.isLoading} />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ViewWorkFlowInspectionDialog);
